var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 25.9v5.3h-9.9V41h-5.3v-9.9h-9.8v-5.3h9.9V16h5.3v9.9H41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68.9v5.3H59v-5.3H84zM68.6 58.3c0.8-0.8 1.8-1.2 2.9-1.2 0.6 0 1.1 0.1 1.6 0.3 0.5 0.2 0.9 0.5 1.3 0.9 0.4 0.4 0.7 0.8 0.9 1.3s0.3 1.1 0.3 1.7c0 0.5-0.1 1-0.3 1.5s-0.5 0.9-0.9 1.3c-0.4 0.4-0.8 0.7-1.3 0.9 -0.5 0.2-1 0.3-1.6 0.3 -0.6 0-1.1-0.1-1.7-0.3 -0.5-0.2-1-0.5-1.3-0.9 -0.4-0.4-0.7-0.8-0.9-1.3 -0.2-0.5-0.3-1-0.3-1.6C67.3 60.1 67.7 59.1 68.6 58.3zM67.7 80.2c0.2-0.5 0.5-0.9 0.9-1.3 0.4-0.4 0.8-0.7 1.3-0.9 0.5-0.2 1-0.3 1.6-0.3 0.6 0 1.1 0.1 1.6 0.3 0.5 0.2 0.9 0.5 1.3 0.9 0.4 0.4 0.7 0.8 0.9 1.3s0.3 1 0.3 1.6c0 0.5-0.1 1-0.3 1.5 -0.2 0.5-0.5 0.9-0.9 1.3 -0.4 0.4-0.8 0.7-1.3 1 -0.5 0.2-1 0.4-1.6 0.4 -0.6 0-1.1-0.1-1.7-0.3 -0.5-0.2-1-0.5-1.3-0.9 -0.4-0.4-0.7-0.8-0.9-1.3 -0.2-0.5-0.3-1-0.3-1.6C67.3 81.2 67.4 80.7 67.7 80.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 95h45V50H5V95zM16.1 63.7l4-4 8.4 8.5 8.5-8.5 4 4 -8.5 8.5 8.5 8.5 -4 4 -8.5-8.5 -8.5 8.5 -4-4 8.5-8.5L16.1 63.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 25.5h18v6.7h-18V25.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.187d8bf01698e863db5f1d65fd9f133f.svg";
export { ForwardRef as ReactComponent };